import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import styled from "styled-components";

import { KeepoLoader } from "../../components/KeepoLoader";
import { usePaymentsEligible } from "../../hooks/PaymentsEligible";
import { useSitePath } from "../../hooks/SitePath";

/**
 * Cobranças' screens only for people in Brazil (an account in reais): anyone else, even by its address, goes back to
 * the Keepo. While the account loads, the Keepo's loader (no glimpse of the screen for who can't use it); when it
 * can't be read, the screen as usual (the API stops anyone else, and its own load says why).
 */
export const PaymentsOnly = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const eligible = usePaymentsEligible();
  const sitePath = useSitePath();

  if (eligible === "loading") {
    return (
      <Loading role="status" aria-label={t("pages.settings.payments.loading")}>
        <KeepoLoader size={40} color="var(--color-neutral-white)" />
      </Loading>
    );
  }
  if (eligible === false) {
    // the Keepo's own address (the old /keepo would be redirected to it once more)
    return <Navigate to={sitePath()} replace />;
  }
  return <>{children}</>;
};

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;
